<div class="stepper-container px-3">
    <!-- Indicador de pasos -->
    <div class="row">
       <!--  <div class="text-muted mb-2">
            {{'Paso '+ pasoActual+' de '+(pasos.length)}}
        </div> -->
    </div>
    <div>
        <div class="d-flex justify-content-between text-center">
            <div *ngFor="let paso of pasos; let i = index" class="step" [class.active]="(i + 1) == pasoActual">
                <div class="step-icon">{{i + 1}}</div>
                <div class="step-label">{{paso}}</div>
            </div>
        </div>
    </div>
    <hr>
    <!-- Contenido del formulario -->
    <div class="row ">
        <ng-content></ng-content>
    </div>

    <div class="d-flex justify-content-between align-items-center pt-4">
      <!--button class="btn btn-outline-secondary px-4 py-2 rounded-pill fw-semibold" (click)="retroceder()" [disabled]="pasoActual === 1 || pasoActual === pasos.length">
        <i class="bi bi-arrow-left me-1"></i> Atrás
      </button-->

      <button 
        class="btn btn-primary px-4 py-2 rounded-pill fw-semibold"
        (click)="avanzar()"
        [disabled]="pasoActual === pasos.length"
        *ngIf="pasoActual < pasos.length">
        Siguiente <i class="bi bi-arrow-right ms-1"></i>
      </button>
    </div>

</div>